export const MESSAGE_ENCOURAGE_KEY = 'motors-post-call-message-encourage';
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

interface StorageMessageEncourage {
    [key: string]: {
        t: number;
    }
}

const genKey = (adId: number, userId?: number) => {
    return `${adId}-${userId}`;
};

export const getAll = () => {
    const value = localStorage.getItem(MESSAGE_ENCOURAGE_KEY);
    try {
        return value ? JSON.parse(value) as StorageMessageEncourage : {};
    } catch (_) {
        return {};
    }
};

export const set = (adId: number, userId: number) => {
    const all = getAll();
    const key = genKey(adId, userId);
    all[key] = { t: Date.now() };
    localStorage.setItem(MESSAGE_ENCOURAGE_KEY, JSON.stringify(all));
};

// 24 hours only show once
export const canShow = (adId: number, userId: number) => {
    const key = genKey(adId, userId);
    const all = getAll();
    const value = all[key];
    if (value && Date.now() - value.t < ONE_DAY_IN_MS) return false;
    return true;
};
